import React from 'react';

export default function Navbar() {
  return (
    <div>
      <a href="/">Home</a>
    </div>
  );
}
